"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Dollar24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "dollar-24", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M13,1 L12.9994838,4.04864914 C14.9410968,4.24246316 16.4934391,5.00644165 17.6414343,6.17971014 L17.6414343,6.17971014 L16.4462151,7.5942029 C15.250996,6.29565217 13.5776892,5.73913043 11.8326693,5.73913043 C9.94422311,5.73913043 8.55776892,6.73623188 8.55776892,8.19710145 C8.55776892,11.6753623 18,9.68115942 18,15.4550725 C18,17.521935 16.6399327,19.668757 13.0014079,19.9652926 L13,23 L11,23 L10.9992892,19.9409574 C8.80609001,19.7042946 7.12955411,18.7772066 6,17.542029 L6,17.542029 L7.19521912,16.057971 C8.22310757,17.2173913 9.94422311,18.284058 12.1912351,18.284058 C15.0358566,18.284058 15.9442231,16.8 15.9442231,15.5942029 C15.9442231,11.6057971 6.50199203,13.8318841 6.50199203,8.31304348 C6.50199203,6.04036403 8.36173455,4.39357604 10.9990849,4.06156019 L11,1 L13,1 Z", id: "Combined-Shape", fill: "#000000" })));
}
function Dollar24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Dollar24Svg, Object.assign({}, svgProps)));
}
exports.default = Dollar24;
//# sourceMappingURL=Dollar24.js.map